module.exports = __webpack_public_path__ + "static/media/ic_popup_kyc_pending.99b5094d.svg";